export default __webpack_public_path__ + "static/media/40.f5a2128a.svg";